import { getNonZTime } from './getNonZTime';
import { isBefore } from 'date-fns';

export const getLowestUnexpiredSegment = (segments) => {
  const today = new Date();
  const lowestUnexpiredSegment = segments.reduce(
    (currentLowest, testSegment) => {
      const zt = getNonZTime(testSegment.EndDate);

      const todayIsBeforeSegmentEnd = isBefore(
        today,
        zt
      );

      if (!todayIsBeforeSegmentEnd && currentLowest) {
        return currentLowest;
      } else if (!todayIsBeforeSegmentEnd) {
        return;
      }

      const testSegmentEndsBeforeAcc = !currentLowest
        ? true
        : isBefore(
            getNonZTime(testSegment.EndDate),
            getNonZTime(currentLowest.EndDate),
          );

      const valueToReturn = testSegmentEndsBeforeAcc ? testSegment : currentLowest;

      return valueToReturn;
    },undefined
  );

  return lowestUnexpiredSegment.SegmentUID;
};
